import classnames from 'classnames';

/**
 * Type primitives shared by the two inner-printer receipts (InnerPrinterReceipt and
 * InnerPrinterOrderHistoryReceipt). Sizes here are physical: the receipt DOM is screenshotted
 * at scale: 1, so 1 CSS px == 1 printer dot.
 */

export const Section = ({ borderTop, borderBottom, children }) => (
  <div
    className={classnames('py-4 border-[5px] border-x-0 border-black', {
      'border-t-0': !borderTop,
      'border-b-0': !borderBottom,
    })}
  >
    {children}
  </div>
);

export const H3 = ({ noMargin, center, noUnderline, regular, className, children }) => (
  <h3
    className={classnames(
      'mb-2 pb-0 text-black font-semibold text-[28px] leading-[39px] border-b border-black inline-block',
      {
        'mb-0': noMargin,
        'text-center': center,
        'font-normal': regular,
        '!border-b-0': noUnderline,
      },
      className,
    )}
  >
    {children}
  </h3>
);

// `wide` comes from usePaperWidth's isWidePaper and is threaded down from the receipt: on a
// roll wider than the Sunmi default the type steps up, and nothing but `sub` lines — which
// stay deliberately subordinate — is allowed below 24px.
export const Paragraph = ({
  noMargin,
  center,
  bold,
  italic,
  shrink,
  noShrink,
  rightPadding,
  big,
  sub,
  wide,
  children,
}) => (
  <p
    className={classnames('mb-0 pb-0 text-black font-medium', {
      'mb-0': noMargin,
      'text-center': center,
      'font-semibold': bold,
      italic: italic,
      'flex-shrink': shrink,
      'flex-none': noShrink,
      'pr-2': rightPadding,
      'text-[20px] leading-[30px]': !wide,
      'text-[24px] leading-[32px]': wide,
      // `big` wins over `sub` explicitly rather than by Tailwind's emission order, since both
      // branches are !-important and no call site combines them today.
      '!text-[22px]': big && !wide,
      '!text-[26px] !leading-[32px]': big && wide,
      // No leading here: this replaces a `[&_*]:text-sm` override, and `text-sm` carries no
      // line-height in this theme (Theme.font.size is a plain map), so it kept leading-[30px].
      '!text-[14px]': sub && !big && !wide,
      '!text-[22px] !leading-[30px]': sub && !big && wide,
    })}
  >
    {children}
  </p>
);
